import moment, { Moment, MomentInput } from "moment";
import { DateFormatT } from "../services/date-time-format/date-time-format.service";
import { ITimesTemp } from "@wind-log_library/fe-component-library";
import * as momentTZ from 'moment-timezone';

export function getDateFormat(type: string): DateFormatT {
  switch (type) {
    case 'hours': return 'dmy';
    case 'days':  return 'my';
    case 'months': return 'y';
    case 'months_acc': return 'y';
    default: return 'dmy';
  }
}

export function round10MinClosest(date?: MomentInput): Moment {
  const momentDate = moment(date);
  const minutes = momentDate.minute();
  const remainder = minutes % 10;
  if (remainder < 5) {
    return  round10MinLow(momentDate);
  } else {
    return round10MinHigh(momentDate);
  }
}

export function round10MinLow(date?: MomentInput): Moment {
  const momentDate = moment(date);
  return momentDate.startOf('minute').subtract(momentDate.minute() % 10, 'minutes');
}

export function round10MinHigh(date?: MomentInput): Moment {
  return moment(date).startOf('minute').add(10 - (moment(date).minute() % 10 || 10), 'minutes');
}

export function setMonthList(startMonth: MomentInput) {
  const currentMonth = moment();
  const numMonths = currentMonth.diff(startMonth, 'months');
  return Array.from({ length: numMonths + 1 }, (_, i) =>
    currentMonth.clone().subtract(i, 'months').format('MMMM YYYY')
  );
}

export function outMonthDuration(startDate: Date, endDate: Date, months = 1): boolean {
  return moment(endDate).valueOf() > moment(startDate).add(months, 'month').valueOf();
}

export function addMonth(date: Date): Date {
  return new Date(moment(date).add(1, 'month').valueOf())
}

export function addMonthButOneMs(date: Date, months: number = 1): Date {
  let month = moment(date).add(months, 'month').valueOf();
  return new Date(--month);
}
export function sameRange(ts1: ITimesTemp, ts2: ITimesTemp) {
  return ts1.startTS === ts2.startTS && ts1.endTS === ts2.endTS;
}
